import React from "react";
import {withStyles} from "@material-ui/core/styles";
import NumberFormat from "react-number-format";
import PropTypes from "prop-types";

const valueLimit = (inputObject,maxValue = 99999999.99) => {
    const { value } = inputObject;
    if (value < maxValue) return inputObject;
}

const FormFieldDecimal = props => {
    const { inputRef, onChange, prefix, suffix, classes, ...other } = props;

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value,
                    },
                });
            }}
            thousandSeparator={'.'}
            decimalSeparator={','}
            decimalScale={2}
            fixedDecimalScale
            isNumericString
            prefix={prefix || ''}
            suffix={suffix || ''}
            allowNegative={false}
            isAllowed={valueLimit}
        />
    );
}
FormFieldDecimal.propTypes = {
    inputRef: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};

const styles = theme => ({});

export default withStyles(styles)(FormFieldDecimal);
